<template>
  <div
    id="mobile-menu-container"
    class="mobile-menu-container"
    :class="{ open: isMenuOpen }"
  >
    <div class="mobile-menu-header">
      <div class="div-button">
        <a class="nft-button"></a>
        <!-- <a class="nft-button" href="http://cervezaindionft.com/" target="_blank">NFT</a> -->
      </div>
      <div class="mobile-menu-icon-container">
        <img
          @click="selectHomeOption('campaigns') & headerGA4Click('click', 'campañas', 'header')"
          :src="indioIcon"
          alt="logo de Indio"
        />
      </div>
      <div class="hamburguer-container">
        <div id="nav-icon3" :class="{ open: isMenuOpen }" @click="openMenu()">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
    <div class="mobile-menu-row">
      <div class="mobile-menu-options-container">
        <!-- <div>
          <a class="rockid_mobile" href="https://www.indio.com.mx/rockid">ROCK ID</a>
        </div> -->
        <!-- <div
          @click="selectMobileOption('campaigns') & headerGA4Click('click', 'campañas', 'header')"
          :class="{ active: getActiveSection === 'campaigns' }"
          class="mobile-menu-option"
        >
          <h2>CAMPAÑAS</h2>
        </div> -->
        <!-- <div>
          <a class="rockid_mobile" @click="headerGA4Click('click', 'código indio', 'header')" href="https://indio.com.mx/documentales/">CÓDIGO INDIO</a>
        </div> -->
        <div
          @click="selectMobileOption('history') & headerGA4Click('click', 'historia', 'header')"
          :class="{ active: getActiveSection === 'history' }"
          class="mobile-menu-option"
        >
          <h2>HISTORIA</h2>
        </div>
        <div
          @click="selectMobileOption('beer') & headerGA4Click('click', 'cerveza indio', 'header')"
          :class="{ active: getActiveSection === 'beer' }"
          class="mobile-menu-option"
        >
          <h2>CERVEZA INDIO</h2>
        </div>
        
        <!-- <div
          @click="selectMobileOption('sustainable')"
          :class="{ active: getActiveSection === 'sustainable' }"
          class="mobile-menu-option"
        >
          <h2>COMPROMISO SUSTENTABLE</h2>
        </div> -->
        <div
          @click="selectMobileOption('retailers') & headerGA4Click('click', 'donde comprar', 'header')"
          :class="{ active: getActiveSection === 'retailers' }"
          class="mobile-menu-option"
        >
          <h2>DÓNDE COMPRAR</h2>
        </div>
        <div class="div-button-two">
          <a class="nft-button-two" @click="headerGA4Click('click', 'indio agave', 'header')" href="https://indio.com.mx/indioagave">INDIO AGAVE</a>
        </div>
         <div class="social-networks">
        <a
          id="facebook"
          class="social-icon"
          target="_blank"
          href="https://www.facebook.com/cervezaindio/" @click="socialClick('Facebook','Interaction') & socialGA4Click('click', 'redes sociales :: facebook', 'header')"
          ><img :src="fbIconImage" alt="Facebook"
        /></a>
        <a
          id="instagram"
          class="social-icon"
          target="_blank"
          href="https://www.instagram.com/cervezaindio/" @click="socialClick('Instagram','Interaction') & socialGA4Click('click', 'redes sociales :: instagram', 'header')"
          ><img :src="inIconImage" alt="Instagram"
        /></a>
        <a
          id="twitter"
          class="social-icon"
          target="_blank"
          href="https://twitter.com/cervezaindio" @click="socialClick('Twitter','Interaction') & socialGA4Click('click', 'redes sociales :: twitter', 'header')"
          ><img :src="twIconImage" alt="Twitter"
        /></a>
        <a
          id="youtube"
          class="social-icon"
          target="_blank"
          href="https://www.youtube.com/user/cervezaindio" @click="socialClick('Youtube','Interaction') & socialGA4Click('click', 'redes sociales :: youtube', 'header')"
          ><img :src="ytIconImage" alt="Youtube"
        /></a>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import indioIcon from "@/assets/Indio_Logo_Simple.png";
import fbIcon from "@/assets/fbIcon.png";
import twIcon from "@/assets/twIcon.png";
import ytIcon from "@/assets/ytIcon.png";
import inIcon from "@/assets/instaIcon.png";

import { mapActions, mapGetters } from "vuex";
import tagFunctions from '@/utils/tagFunctions.js'

export default {
  name: "MobileMenu",
  computed: {
    ...mapGetters(["getActiveSection"]),
  },
  methods: {
    ...mapActions({
      setActiveSection: "setActiveSection",
    }),
    socialClick(socialNetwork, action){
      tagFunctions.evSocialNetworkPush(socialNetwork, action)
    },
    socialGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    headerGA4Click(action, element, section) {
      tagFunctions.user_interactionPush(action, element, section)
    },
    openMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    selectHomeOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
    },
    selectMobileOption(option) {
      this.setActiveSection({
        willScroll: true,
        section: option,
      });
      this.$router.push({ path: option }).catch(err => {
    // Ignore the vuex err regarding  navigating to the page they are already on.
    if (
      err.name !== 'NavigationDuplicated' &&
      !err.message.includes('Avoided redundant navigation to current location')
    ) {
      // But print any other errors to the console
      throw err;
    }
  });
      this.openMenu();
    },
  },
  data() {
    return {
      isMenuOpen: false,
      indioIcon,
      fbIconImage: fbIcon,
      twIconImage: twIcon,
      ytIconImage: ytIcon,
      inIconImage: inIcon,
    };
  },
};
</script>

<style scoped lang="scss">
@import "~@/styles/mobilemenu.scss";
</style>
